import { Directive, forwardRef, OnChanges, SimpleChanges, Type, input } from '@angular/core';
import { NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { CashTransferAccount } from './cash-transfer.domain';

/**
 * Validates empty to-account list, in case user selected from-account
 */
@Directive({
  selector: '[tdWbCashTransferToAccountValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<CashTransfersToAccountValidatorDirective> => CashTransfersToAccountValidatorDirective),
    multi: true
  }]

})
export class CashTransfersToAccountValidatorDirective implements Validator, OnChanges {
  // Tuple with <selectedFrom, list of toAccounts found>
  readonly tdWbCashTransferToAccountValidator = input<[
    CashTransferAccount,
    Array<CashTransferAccount>
]>(undefined);

  private onChange: (changes: SimpleChanges) => void;

  validate(): ValidationErrors | null {
    const selectedFromAccount = this.tdWbCashTransferToAccountValidator()[0];
    const toAccounts = this.tdWbCashTransferToAccountValidator()[1];

    if (selectedFromAccount !== undefined && toAccounts !== undefined && toAccounts !== null) {
      if (toAccounts.length === 0) {
        return { noToAccounts: true };
      }
    }
    return null;
  }

  registerOnValidatorChange(fn: (changes: SimpleChanges) => void): void {
    this.onChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.onChange !== undefined) {
      this.onChange(changes);
    }
  }
}
